// tslint:disable: max-line-length
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AgGridModule } from 'ag-grid-angular';
import { OrderListModule } from 'primeng/orderlist';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';
//import {FullCalendarModule} from 'primeng/fullcalendar';
import { FullCalendarModule } from '@fullcalendar/angular';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { AppRoutingModule } from './app-routing.module';

import {
  DevwareCoreModule,
  DevwareOrmModule,
  DevwareUIModule,
  DevwareAGGridModule,
  DevwareUILayoutModule,
  DevwareUIMetaDataModule,
  DevwareAdminModule,
  DevwareUiWizardModule,
  DevwareMediaModule,
  DwUserContextDynamicHandlerToken,
  DwMenuProcessorToken
} from '@devwareapps/devware-cap';

import { AppDevwareConfigProviderService } from './app-devware-config-provider.service';


import { AppComponent } from './pages/app/app.component';
import { HomeComponent } from './features/shared/pages/home/home.component';
//import { ExaminerBookingCalendarComponent } from './features/examiner/components/examiner-booking-calendar-old/examiner-booking-calendar.component';
import { ExaminerBookingSearchResultsComponent } from './features/booking/components/examiner-booking-search-results/examiner-booking-search-results.component';
import { CurrentStudentContextService } from './features/shared/contexts/current-student-context/current-student-context.service';
import { ExaminerBookingSearchResultComponent } from './features/booking/components/examiner-booking-search-result/examiner-booking-search-result.component';
import { CurrentPilotExaminerContextService } from './features/shared/contexts/current-pilot-examiner/current-pilot-examiner.service';
import { ScheduleSelectorComponent } from './features/booking/components/schedule-selector/schedule-selector.component';
import { ScheduleDetailComponent } from './features/booking/components/schedule-detail/schedule-detail.component';
import { GoogleCalendarConsentComponent } from './features/calendar/components/google-calendar-consent/google-calendar-consent.component';
import { CalendarSettingsModalComponent } from './features/calendar/components/calendar-settings-modal/calendar-settings-modal.component';
import { CalendarWeekdayComponent } from './features/calendar/components/calendar-weekday/calendar-weekday.component';

import { DayPilotModule } from 'daypilot-pro-angular';

import { NgbDatepickerModule, NgbTimepickerModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { TreeModule } from 'primeng/tree';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { ExaminerCheckRideUtilComponent } from './features/examiner/components/examiner-check-ride-util/examiner-check-ride-util.component';
import { PilexosHomeComponent } from './features/homepage/components/home-page/home-page.component';
import { AnnonymousHomeViewComponent } from './features/homepage/components/annonymous-home-view/annonymous-home-view.component';
import { AdditionalContentComponent } from './features/homepage/components/additional-content/additional-content.component';
import { MenuItemCardComponent } from './features/homepage/components/menu-item-card/menu-item-card.component';
import { UserRegistrationComponent } from './features/homepage/components/user-registration/user-registration.component';
import { ExaminerDashboardComponent } from './features/examiner/components/examiner-dashboard/examiner-dashboard.component';
import { DashboardCheckrideCardComponent } from './features/shared/components/dashboard-checkride-card/dashboard-checkride-card.component';
import { DashboardTaskListComponent } from './features/shared/components/dashboard-task-list/dashboard-task-list.component';
import { ExaminerHomeComponent } from './features/examiner/components/examiner-home/examiner-home.component';
import { SchoolHomeComponent } from './features/schools/components/school-home/school-home.component';
import { HomeDashboardComponent } from './features/shared/components/home-dashboard/home-dashboard.component';
import { HomeDashboardSkeletonComponent } from './features/shared/components/home-dashboard-skeleton/home-dashboard-skeleton.component';
import { AuthenticatedHomeViewComponent } from './features/homepage/components/authenticated-home-view/authenticated-home-view.component';
import { DwTaskContainerComponent } from './features/z-devware/tasks/components/dw-task-container/dw-task-container.component';


import { ChartModule } from 'primeng/chart';
import { ExaminerFinancialSnapshotComponent } from './features/examiner/components/examiner-financial-snapshot/examiner-financial-snapshot.component';
import { DwMiniTileComponent } from './features/z-devware/visualizations/components/dw-mini-tile/dw-mini-tile.component';
import { ApplicantDashboardComponent } from './features/applicant/components/applicant-dashboard/applicant-dashboard.component';
import { ApplicantHomeComponent } from './features/applicant/components/applicant-home/applicant-home.component';
import { ExaminerLocationUtilComponent } from './features/examiner/components/examiner-location-util/examiner-location-util.component';
import { ExaminerPublicProfileComponent } from './features/examiner/components/examiner-public-profile/examiner-public-profile.component';
import { UsreAvatarComponent } from './features/shared/components/user-avatar/usre-avatar.component';
import { PaymentInfoComponent } from './features/payments/components/payment-info/payment-info.component';
import { PaymentModalComponent } from './features/payments/components/payment-modal/payment-modal.component';
import { CheckridePaymentUtilComponent } from './features/payments/components/checkride-payment-util/checkride-payment-util.component';
import { ExaminerBookingAssignedComponent } from './features/booking/components/examiner-booking-assigned/examiner-booking-assigned.component';
import { DateTimeDisplayControlComponent } from './features/shared/components/date-time-display-control/date-time-display-control.component';
import { DurationDisplayControlComponent } from './features/shared/components/duration-display-control/duration-display-control.component';
import { CheckridePaymentRefundActionService } from './features/payments/actions/checkride-payment-refund-action.service';
import { EmailDisplayComponent } from './features/shared/components/email-display/email-display.component';
import { DurationControlComponent } from './features/shared/components/duration-control/duration-control.component';
import { DwChartTileComponent } from './features/z-devware/visualizations/components/dw-chart-tile/dw-chart-tile.component';
import { FinancialDashboardComponent } from './features/financials/components/financial-dashboard/financial-dashboard.component';
import { AdminFinancialsComponent } from './features/financials/components/admin-financials/admin-financials.component';
import { GridReturnToFinancialsActionService } from './features/financials/grid-actions/grid-return-to-financials/grid-return-to-financials-action.service';
import { FinancialDashboardFiltersComponent } from './features/financials/components/financial-dashboard-filters/financial-dashboard-filters.component';
import { ExaminerFinancialsComponent } from './features/financials/components/examiner-financials/examiner-financials.component';
import { ExaminerCalendarCheckComponent } from './features/examiner/components/examiner-calendar-check-util/examiner-calendar-check.component';
import { CheckridePaymentUtilExaminerComponent } from './features/payments/components/checkride-payment-util-examiner/checkride-payment-util-examiner.component';
import { ApplicantCheckRideUtilComponent } from './features/applicant/components/applicant-check-ride-util/applicant-check-ride-util.component';
import { RebookApplicantCheckrideActionService } from './features/booking/actions/rebook-applicant-checkride/rebook-applicant-checkride-action.service';
import { RebookExaminerCheckrideActionService } from './features/booking/actions/rebook-examiner-checkride/rebook-examiner-checkride-action.service';
import { AcceptProposedDateActionService } from './features/booking/actions/accept-proposed-date/accept-proposed-date-action.service';
import { QuestionEditControlComponent } from './features/plan-of-action/components/question-edit-control/question-edit-control.component';
import { GenerateSectionsModalComponent } from './features/plan-of-action/components/generate-sections-modal/generate-sections-modal.component';
import { GenerateSectionsActionService } from './features/plan-of-action/actions/generate-sections-action.service';
import { GenerateQuestionsActionService } from './features/plan-of-action/actions/generate-questions-action.service';
import { PlanOfActionSectionsComponent } from './features/plan-of-action/components/plan-of-action-sections/plan-of-action-sections.component';
import { SelectSectionsComponent } from './features/plan-of-action/components/select-sections/select-sections.component';
import { SelectAcsCodesComponent } from './features/plan-of-action/components/select-acs-codes/select-acs-codes.component';
import { GenerateQuestionsModalComponent } from './features/plan-of-action/components/generate-questions-modal/generate-questions-modal.component';
import { AddRequiredAcsCodesActionService } from './features/plan-of-action/actions/add-required-acs-codes-action.service';
import { RequiredAcsCodesGridComponent } from './features/plan-of-action/components/required-acs-codes-grid/required-acs-codes-grid.component';
import { RequiredAcsCodesGridConfigComponent } from './features/plan-of-action/components/required-acs-codes-grid/required-acs-codes-grid-config.component';
import { PlanOfActionSectionComponent } from './features/plan-of-action/components/plan-of-action-section/plan-of-action-section.component';
import { PlanOfActionQuestionComponent } from './features/plan-of-action/components/plan-of-action-question/plan-of-action-question.component';
import { PlanOfActionDataSourceService } from './features/plan-of-action/data-source/plan-of-action-data-source.service';
import { PlanOfActionExecuteComponent } from './features/plan-of-action/components/plan-of-action-execute/plan-of-action-execute.component';
import { PlanOfActionExecuteSectionComponent } from './features/plan-of-action/components/plan-of-action-execute-section/plan-of-action-execute-section.component';
import { PlanOfActionExecuteQuestionComponent } from './features/plan-of-action/components/plan-of-action-execute-question/plan-of-action-execute-question.component';
import { PlanOfActionSectionEditComponent } from './features/plan-of-action/components/plan-of-action-section-edit/plan-of-action-section-edit.component';
import { SelectAcsCodesModalComponent } from './features/plan-of-action/components/select-acs-codes-modal/select-acs-codes-modal.component';
import { CheckrideFormDataSourceService } from './features/booking/data-sources/check-ride-from-data-source.service';
import { CheckridePlanOfActionUtilComponent } from './features/plan-of-action/components/checkride-plan-of-action-util/checkride-plan-of-action-util.component';
import { CheckrideCreatePOAActionService } from './features/plan-of-action/actions/checkride-create-poa-action.service';
//import { ExecutePOACompleteActionService } from './features/plan-of-action/actions/execute-poa-complete-checkride.service';
import { ACSWrittenDataContextService } from './features/plan-of-action/contexts/acs-written-data-context.service';
import { CheckrideSaveAndGotoPOAActionService } from './features/plan-of-action/actions/checkride-save-and-open-poa-action.service';
import { POASaveAndExecuteActionService } from './features/plan-of-action/actions/poa-save-and-execute-action.service';
import { POACompleteCheckrideActionService } from './features/plan-of-action/actions/poa-complete-checkride-action.service';
import { POAStartCompleteCheckrideActionService } from './features/plan-of-action/actions/poa-start-complete-checkride-action.service';
import { AddMissedAcsCodesActionService } from './features/plan-of-action/actions/add-missed-acs-codes-action.service';
import { PoaPrintOptionsModalComponent } from './features/plan-of-action/components/poa-print-options-modal/poa-print-options-modal.component';
import { POAGeneratePdfActionService } from './features/plan-of-action/actions/poa-generate-pdf-action.service';
import { AcsCodeLookupDataSourceService } from './features/plan-of-action/data-source/acs-code-lookup-data-source.service';
import { ExaminerTaskFilterComponent } from './features/examiner/filters/examiner-task-filter/examiner-task-filter.component';
import { ScheduleHoldInfoComponent } from './features/booking/components/schedule-hold-info/schedule-hold-info.component';
import { SchoolDashboardComponent } from './features/schools/components/school-dashboard/school-dashboard.component';

import { DividerMenuComponent } from './features/shared/components/divider-menu/divider-menu.component';
import { UserTypeMenuComponent } from './features/shared/components/user-type-menu/user-type-menu.component';
import { PilexosUserContextCustomizerService } from './features/shared/contexts/pilexos-user-context-customizer.service';
import { PlaceholderMenuComponent } from './features/shared/components/placeholder-menu/placeholder-menu.component';
import { SchoolProgramTypesContextService } from './features/schools/contexts/school-program-types-context.service';
import { CalendarMonthViewComponent } from './features/calendar/components/calendar-month-view/calendar-month-view.component';
import { CheckridePaymentUtilSchoolComponent } from './features/payments/components/checkride-payment-util-school/checkride-payment-util-school.component';
import { ExaminerBookingSearchResultsConfigComponent } from './features/booking/components/examiner-booking-search-results-config/examiner-booking-search-results-config.component';
import { SchoolCheckRideSearchUtilComponent } from './features/schools/components/school-check-ride-search-util/school-check-ride-search-util.component';
import { ExaminerBookingMultipleCreationComponent } from './features/booking/components/examiner-booking-multiple-creation/examiner-booking-multiple-creation.component';
import { ExaminerBookingCreationItemComponent } from './features/booking/components/examiner-booking-creation-item/examiner-booking-creation-item.component';
import { DateTimeDisplayFormControlComponent } from './features/shared/components/date-time-display-form-control/date-time-display-form-control.component';
import { ScheduleHoldInfoMultipleComponent } from './features/booking/components/schedule-hold-info-multiple/schedule-hold-info-multiple.component';
import { SchoolFinancialsComponent } from './features/financials/components/school-financials/school-financials.component';
import { AddCardModalComponent } from './features/payments/components/add-card-modal/add-card-modal.component';
import { PaymentCardDetailsComponent } from './features/payments/components/payment-card-details/payment-card-details.component';
import { ExaminerSettingsContextService } from './features/examiner/contexts/examiner-settings-context.service';
import { AddPaymentMethodActionService } from './features/payments/actions/add-payment-method-action.service';
import { AddPaymentMethodActionConfigComponent } from './features/payments/actions/add-payment-method/config/add-payment-method-action-config/add-payment-method-action-config.component';
import { PilexosHttpInterceptor } from './features/shared/http-interceptors/pilexos-http-interceptor.service';
import { CardSelectionControlComponent } from './features/payments/components/card-selection-control/card-selection-control.component';
import { SchoolBookingPaymentDetailsComponent } from './features/booking/components/school-booking-payment-details/school-booking-payment-details.component';
import { SchoolTaskFilterComponent } from './features/schools/filters/school-task-filter/school-task-filter.component';
import { SchoolCheckRideUtilComponent } from './features/schools/components/school-check-ride-util/school-check-ride-util.component';
import { UserTypeSelectionModalComponent } from './features/shared/components/user-type-selection-modal/user-type-selection-modal.component';
import { ChangeUserTypeActionService } from './features/shared/actions/change-user-type-action.service';
import { SchoolProfileComponent } from './features/schools/components/school-profile/school-profile.component';
import { CurrentSchoolContextService } from './features/shared/contexts/current-school-context/current-school-context.service';
//import { SchoolCalendarComponentOld } from './features/schools/components/school-calendar-old/school-calendar-old.component';
import { SchoolPassRatesComponent } from './features/financials/components/school-pass-rates/school-pass-rates.component';
import { SchoolPublicProfileComponent } from './features/schools/components/school-public-profile/school-public-profile.component';
import { SchoolPublicContextService } from './features/schools/contexts/school-public-context.service';
import { UrlParameterContextService } from './features/shared/contexts/url-parameter-context/url-parameter-context.service';
import { SchoolSubmitApplicantActionService } from './features/schools/actions/school-submit-applicant-action.service';
import { ExaminerPassRatesComponent } from './features/financials/components/examiner-pass-rates/examiner-pass-rates.component';
import { CheckrideAcsWrittenResultAcsTestContextService } from './features/booking/contexts/checkride-acswrittenresult-acstest-context.service';
import { FlightSchoolApplicantFormDataSourceService } from './features/schools/data-sources/flight-school-applicant-form-data-source.service';
import { SchoolFeatureContextService } from './features/schools/contexts/school-features-context.service';
import { FlightSchoolExaminerTrainingContextService } from './features/schools/contexts/flight-school-examiner-training-context.service';
import { FlightSchoolExaminerCurrentContextService } from './features/schools/contexts/flight-school-examiner-current-context.service';
import { FlightSchoolApplicantCurrentContextService } from './features/schools/contexts/flight-school-applicant-current-context.service';
import { SchoolStudentTaskFilterComponent } from './features/schools/filters/school-student-task-filter/school-student-task-filter.component';
import { RebookSchoolCheckrideActionService } from './features/booking/actions/rebook-school-checkride/rebook-school-checkride-action.service';
import { CheckrideResultContextService } from './features/booking/contexts/checkride-result-context.service';
import { ExaminerBlockBookingItemCreateComponent } from './features/schedule-blocks/components/examiner-block-booking-item-create/examiner-block-booking-item-create.component';
import { DwFormDebugLogComponent } from './features/shared/components/dw-form-debug-log/dw-form-debug-log.component';
import { CheckrideCurrentContextService } from './features/booking/contexts/checkride-current-context.service';
import { SchoolSwapStudentModalComponent } from './features/schools/components/school-swap-student-modal/school-swap-student-modal.component';
import { SchoolSwapStudentActionService } from './features/schools/actions/school-swap-student-action.service';
import { DurationSecondsColumnRendererService } from './features/shared/columns/duration-seconds-column-renderer.service';
import { UnitMemberTrainingCurrentColumnRendererService } from './features/schools/columns/unit-member-training-current-column-renderer.service';
import { BookingCalendarComponent } from './features/calendar/components/booking-calendar/booking-calendar.component';
import { ExaminerCalendarComponent } from './features/examiner/components/examiner-calendar/examiner-calendar.component';
import { SchoolCalendarComponent } from './features/schools/components/school-calendar/school-calendar.component';
import { AirportMultiSelectComponent } from './features/shared/components/airport-multi-select/airport-multi-select.component';
import { ConvertToTemplateActionService } from './features/plan-of-action/actions/convert-to-template-action.serviec';
import { CheckrideOutcomeContextService } from './features/booking/contexts/checkride-outcome-context.services';
import { CheckrideTestTypeContextService } from './features/booking/contexts/checkride-test-type-context.service';
import { PlanOfActionOutcomeContextService } from './features/booking/contexts/planofaction-outcome-context.service';
import { PlanOfActionTestTypeContextService } from './features/booking/contexts/planofaction-test-type-context.service';
import { SchoolConvertInstructorActionService } from './features/schools/actions/school-convert-instructor-action.service';
import { PlanOfActionUtilComponent } from './features/plan-of-action/components/plan-of-action-util/plan-of-action-util.component';
import { PlanOfActionCurrentContextService } from './features/plan-of-action/contexts/plan-of-action-current-context.service';
import { PostExamAssessmentComponent } from './features/plan-of-action/components/post-exam-assessment/post-exam-assessment.component';
import { AscCodeReportsComponent } from './features/reports/components/asc-code-reports/asc-code-reports.component';
import { AcsTrendsComponent } from './features/reports/components/acs-trends/acs-trends.component';
import { RoAssessmentAcsMissedCodeFactOpenActionService } from './features/reports/actions/ro-assessment-acs-missed-code-fact-open-action.service';
import { GenericTagFiltersComponent } from './features/shared/components/generic-tag-filters/generic-tag-filters.component';
import { PileoxsMenuProcessorService } from './app-menu-processor.service';
import { ReportDashboardComponent } from './features/reports/dashboard/components/report-dashboard/report-dashboard.component';
import { ReportDashboardGroupHostComponent } from './features/reports/dashboard/components/report-dashboard-group-host/report-dashboard-group-host.component';
import { SchoolPerformanceDashboardComponent } from './features/reports/dashboard/components/school-performance-dashboard/school-performance-dashboard.component';
import { ReportDashboardDesignerComponent } from './features/reports/dashboard/components/report-dashboard-designer/report-dashboard-designer.component';
import { ReportDashboardDesignCanvasComponent } from './features/reports/dashboard/components/report-dashboard-design-canvas/report-dashboard-design-canvas.component';
import { ReportDashboardCreateModalComponent } from './features/reports/dashboard/components/report-dashboard-create-modal/report-dashboard-create-modal.component';
import { ReportDashboardGroupModalComponent } from './features/reports/dashboard/components/report-dashboard-group-modal/report-dashboard-group-modal.component';
import { ReportCustomWidgetHostComponent } from './features/reports/dashboard/components/report-custom-widget-host/report-custom-widget-host.component';
import { ConfiguredReportDashboardPageComponent } from './features/reports/dashboard/components/configured-report-dashboard-page/configured-report-dashboard-page.component';
import { ConfiguredReportDashboardConfigComponent } from './features/reports/dashboard/components/configured-report-dashboard-page/configured-report-dashboard-config.component';
import { ReportFilterPresetSaveModalComponent } from './features/reports/dashboard/components/report-filter-preset-save-modal/report-filter-preset-save-modal.component';
import { ReportFilterPresetManageModalComponent } from './features/reports/dashboard/components/report-filter-preset-manage-modal/report-filter-preset-manage-modal.component';
import { ReportDashboardFilterDesignerModalComponent } from './features/reports/dashboard/components/report-dashboard-filter-designer-modal/report-dashboard-filter-designer-modal.component';
import { UnitMemberQualificationQuestionnaireComponent } from './features/schools/components/unit-member-qualification-questionnaire/unit-member-qualification-questionnaire.component';
import { UnitMemberCurrentStatusComponent } from './features/schools/components/unit-member-current-status/unit-member-current-status.component';
import { UnitMemberPdfOptionsModalComponent } from './features/schools/components/unit-member-pdf-options-modal/unit-member-pdf-options-modal.component';
import { UnitMemberGeneratePdfActionService } from './features/schools/actions/unit-member-generate-pdf-action.service';
import { CheckrideStatusComponent } from './features/booking/components/checkride-status/checkride-status.component';
import { CheckrideStatusConfigComponent } from './features/booking/components/checkride-status-config/checkride-status-config.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    // ExaminerBookingCalendarComponent,
    ExaminerBookingSearchResultsComponent,
    ExaminerBookingSearchResultComponent,
    ScheduleSelectorComponent,
    ScheduleDetailComponent,
    GoogleCalendarConsentComponent,
    CalendarSettingsModalComponent,
    CalendarWeekdayComponent,
    ExaminerCheckRideUtilComponent,
    PilexosHomeComponent,
    AnnonymousHomeViewComponent,
    AuthenticatedHomeViewComponent,
    AdditionalContentComponent,
    MenuItemCardComponent,
    UserRegistrationComponent,
    ExaminerDashboardComponent,
    ExaminerHomeComponent,
    SchoolHomeComponent,
    HomeDashboardComponent,
    HomeDashboardSkeletonComponent,
    DashboardCheckrideCardComponent,
    DashboardTaskListComponent,
    DwTaskContainerComponent,
    ExaminerFinancialSnapshotComponent,
    DwMiniTileComponent,
    DwChartTileComponent,
    ApplicantDashboardComponent,
    ApplicantHomeComponent,
    ExaminerLocationUtilComponent,
    ExaminerPublicProfileComponent,
    UsreAvatarComponent,
    PaymentInfoComponent,
    PaymentModalComponent,
    CheckridePaymentUtilComponent,
    ExaminerBookingAssignedComponent,
    DateTimeDisplayControlComponent,
    DurationDisplayControlComponent,
    EmailDisplayComponent,
    DurationControlComponent,
    FinancialDashboardComponent,
    AdminFinancialsComponent,
    FinancialDashboardFiltersComponent,
    ExaminerFinancialsComponent,
    ExaminerCalendarCheckComponent,
    CheckridePaymentUtilExaminerComponent,
    ApplicantCheckRideUtilComponent,
    QuestionEditControlComponent,
    GenerateSectionsModalComponent,
    PlanOfActionSectionsComponent,
    SelectSectionsComponent,
    SelectAcsCodesComponent,
    GenerateQuestionsModalComponent,
    RequiredAcsCodesGridComponent,
    RequiredAcsCodesGridConfigComponent,
    PlanOfActionSectionComponent,
    PlanOfActionQuestionComponent,
    PlanOfActionExecuteComponent,
    PlanOfActionExecuteSectionComponent,
    PlanOfActionExecuteQuestionComponent,
    PlanOfActionSectionEditComponent,
    SelectAcsCodesModalComponent,
    CheckridePlanOfActionUtilComponent,
    PoaPrintOptionsModalComponent,
    UnitMemberPdfOptionsModalComponent,
    CheckrideStatusComponent,
    CheckrideStatusConfigComponent,
    ExaminerTaskFilterComponent,
    ScheduleHoldInfoComponent,
    SchoolDashboardComponent,
    UserTypeMenuComponent,
    DividerMenuComponent,
    PlaceholderMenuComponent,
    CalendarMonthViewComponent,
    CheckridePaymentUtilSchoolComponent,
    ExaminerBookingSearchResultsConfigComponent,
    SchoolCheckRideSearchUtilComponent,
    ExaminerBookingMultipleCreationComponent,
    ExaminerBookingCreationItemComponent,
    DateTimeDisplayFormControlComponent,
    ScheduleHoldInfoMultipleComponent,
    SchoolFinancialsComponent,
    AddCardModalComponent,
    PaymentCardDetailsComponent,
    AddPaymentMethodActionConfigComponent,
    CardSelectionControlComponent,
    SchoolBookingPaymentDetailsComponent,
    SchoolTaskFilterComponent,
    SchoolCheckRideUtilComponent,
    UserTypeSelectionModalComponent,
    SchoolProfileComponent,
    //SchoolCalendarComponentOld,
    SchoolCalendarComponent,
    SchoolPassRatesComponent,
    SchoolPublicProfileComponent,
    ExaminerPassRatesComponent,
    SchoolStudentTaskFilterComponent,
    ExaminerBlockBookingItemCreateComponent,
    DwFormDebugLogComponent,
    SchoolSwapStudentModalComponent,
    BookingCalendarComponent,
    ExaminerCalendarComponent,
    AirportMultiSelectComponent,
    PlanOfActionUtilComponent,
    PostExamAssessmentComponent,
    AscCodeReportsComponent,
    AcsTrendsComponent,
    GenericTagFiltersComponent,
    CalendarSettingsModalComponent,
    ReportDashboardComponent,
    ReportDashboardGroupHostComponent,
    SchoolPerformanceDashboardComponent,
    ReportDashboardDesignerComponent,
    ReportDashboardDesignCanvasComponent,
    ReportDashboardCreateModalComponent,
    ReportDashboardGroupModalComponent,
    ReportCustomWidgetHostComponent,
    ConfiguredReportDashboardConfigComponent,
    ConfiguredReportDashboardPageComponent,
    ReportFilterPresetSaveModalComponent,
    ReportFilterPresetManageModalComponent,
    ReportDashboardFilterDesignerModalComponent,
    UnitMemberQualificationQuestionnaireComponent,
    UnitMemberCurrentStatusComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OrderListModule,
    InputSwitchModule,
    TabViewModule,
    DropdownModule,
    MultiSelectModule,
    CheckboxModule,

    HttpClientModule,
    AgGridModule.forRoot(),
    BsDropdownModule.forRoot(),
    ChartModule,
    NgbTooltipModule,

    DevwareCoreModule,
    DevwareOrmModule,
    DevwareUIModule,
    DevwareAGGridModule,
    DevwareUILayoutModule,
    DevwareUIMetaDataModule,
    DevwareUiWizardModule,
    DevwareAdminModule,
    DevwareMediaModule,
    FullCalendarModule,
    DayPilotModule, NgbDatepickerModule, NgbTimepickerModule, NgbPopoverModule,
    AppRoutingModule,
  ],
  providers: [
    AppDevwareConfigProviderService,
    CurrentStudentContextService,
    CurrentPilotExaminerContextService,
    CheckridePaymentRefundActionService,
    GridReturnToFinancialsActionService,
    RebookApplicantCheckrideActionService,
    RebookExaminerCheckrideActionService,
    AcceptProposedDateActionService,
    GenerateSectionsActionService,
    GenerateQuestionsActionService,
    AddRequiredAcsCodesActionService,
    PlanOfActionDataSourceService,
    CheckrideFormDataSourceService,
    CheckrideCreatePOAActionService,
    //ExecutePOACompleteActionService,
    ACSWrittenDataContextService,
    POASaveAndExecuteActionService,
    CheckrideSaveAndGotoPOAActionService,
    POAStartCompleteCheckrideActionService,
    POACompleteCheckrideActionService,
    AddMissedAcsCodesActionService,
    POAGeneratePdfActionService,
    UnitMemberGeneratePdfActionService,
    AcsCodeLookupDataSourceService,
    SchoolProgramTypesContextService,
    ExaminerSettingsContextService,
    AddPaymentMethodActionService,
    ChangeUserTypeActionService,
    CurrentSchoolContextService,
    SchoolPublicContextService,
    SchoolFeatureContextService,
    FlightSchoolExaminerTrainingContextService,
    FlightSchoolExaminerCurrentContextService,
    FlightSchoolApplicantCurrentContextService,
    UrlParameterContextService,
    SchoolSubmitApplicantActionService,
    CheckrideAcsWrittenResultAcsTestContextService,
    FlightSchoolApplicantFormDataSourceService,
    RebookSchoolCheckrideActionService,
    CheckrideResultContextService,
    CheckrideCurrentContextService,
    SchoolSwapStudentActionService,
    DurationSecondsColumnRendererService,
    UnitMemberTrainingCurrentColumnRendererService,
    ConvertToTemplateActionService,
    CheckrideOutcomeContextService,
    CheckrideTestTypeContextService,
    PlanOfActionOutcomeContextService,
    PlanOfActionTestTypeContextService,
    SchoolConvertInstructorActionService,
    PlanOfActionCurrentContextService,
    RoAssessmentAcsMissedCodeFactOpenActionService,
    {
      provide: DwUserContextDynamicHandlerToken,
      useClass: PilexosUserContextCustomizerService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PilexosHttpInterceptor,
      multi: true
    },
    {
      provide: DwMenuProcessorToken,
      useClass: PileoxsMenuProcessorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [
    UserRegistrationComponent
  ]
})
export class AppModule { }
